export default __webpack_public_path__ + "流沙入海.jpg";